<div class="main-menu" @dropdownTrigger>
  @for (menuItem of menuItems; track menuItem) {
    <div class="main-menu-item" (click)="onMenuItemClicked(menuItem)">
      <img [src]="menuItem.icon" />
      <span>{{menuItem.description}}</span>
    </div>
  }
</div>
